<section id="trust" class="wl-section trust">
  <div class="wl-inner inner">
    <app-section-heading
      eyebrow="Niezawodność"
      title="Nic się nie zepsuje"
      subtitle="Zaprojektowane na żywioł sali weselnej." />
    <div class="wl-4col grid">
      @for (item of items; track item.title) {
        <div class="tile">
          <div class="check">✓</div>
          <h4 class="tile-title">{{ item.title }}</h4>
          <p class="tile-text">{{ item.text }}</p>
        </div>
      }
    </div>
    <div class="gcp">
      <img src="images/gcp-logo.png" alt="Google Cloud" class="gcp-logo">
      <div class="gcp-text">
        <p class="gcp-title">Działa na Google Cloud Platform</p>
        <p class="gcp-desc">Stoimy na infrastrukturze chmurowej <span class="gcp-brand">Google Cloud</span> - tej samej, na której działają największe serwisy świata. Rozwiązania chmurowe dają nam praktycznie <strong>100% pewności</strong>, że w trakcie Waszego wesela nic nie padnie.</p>
      </div>
    </div>
  </div>
</section>
